export default {
    pmusers_main_title: 'Usuarios de Platform Manager',
    pmusers_main_name: 'Nombre',
    pmusers_main_username: 'Usuario',
    pmusers_main_email: 'Correo',
    pmusers_main_status: 'Estado',
    pmusers_main_profile: 'Perfiles',
    pmusers_main_created: 'Creado',
    pmusers_main_updated: 'Actualizado',
    pmusers_main_add_user: 'Agregar usuario',
    pmusers_main_roles: 'Roles',
    pmusers_main_edit_user: 'Editar usuario',
    pmusers_main_delete_user: 'Borrar usuario',
    pmusers_main_activate_user: 'Activar usuario',
    pmusers_main_deactivate_user: 'Desactivar usuario',
    pmusers_main_change_password: 'Cambiar contraseña',
    pmusers_main_reset_password: 'Restablecer contraseña',
    pmusers_main_last_name: 'Apellido',
    pmusers_main_force_logout: 'Forzar el cierre de sesión',
    pmusers_main_logged_out: 'El usuario ha cerrado la sesión',
    pmusers_main__not_logged_out: 'No fue posible cerrar la sesión del usuario',
    pmusers_main_do_you_want_to_force_user_logout: '¿Desea forzar el cierre de sesión del usuario?',
    pmusers_main_logout: 'Cerrar la sesión',
    pmusers_main_registration_status: 'Estado de registro',
    pmusers_main_id: 'ID',
};